import { privateApi } from "@core/libs/axios";
import { handleResponse } from "@core/libs/axios/serviceHandler";
import type { TEditUserSchema } from "@core/types";

export async function editUser(
  payload: TEditUserSchema,
  signal?: AbortSignal,
): Promise<void> {
  await handleResponse<void>(
    privateApi.patch("user/edit_info", payload, { signal }),
  );
}
